import { FieldErrors, UseFormRegister, UseFormWatch } from "react-hook-form";
import { FormTypes } from "../../types/FormTypes";

interface IInputsTemperatureRange {
  register: UseFormRegister<FormTypes>;
  errors: FieldErrors<FormTypes>;
  watch: UseFormWatch<FormTypes>;
  onBlurHandler: (event: any) => void
}

function InputsTemperatureRange(props: IInputsTemperatureRange) {
  const { errors, register, watch, onBlurHandler } = props;
  const temperatureRange = watch("temperatureRangeRange");

  return (
    <div>
      <div className="mr-100 d-flex">
        <div className="d-flex">
          <div>
            <div className="d-flex">
              <input
                type="number"
                step="any"
                placeholder="Typical ambient"
                {...register("temperatureRangeTemp1", {
                  min: -63.4,
                  max: 248,
                  valueAsNumber: true,
                  onBlur: onBlurHandler
                })}
              />
              <p
                className="nowrap mr-25"
                style={{ marginBottom: "0px", marginLeft: "5px" }}
              >
                &deg;F to
              </p>
            </div>
            <small className="input-small-text">-63.4 - 248 &deg;F</small>
          </div>
          <div>
            <div className="d-flex">
              <input
                type="number"
                placeholder="Typical ambient"
                step="any"
                {...register("temperatureRangeTemp2", {
                  min: -63.4,
                  max: 248,
                  valueAsNumber: true,
                  onBlur: onBlurHandler
                })}
              />
              <p
                className="nowrap mr-25"
                style={{ marginBottom: "0px", marginLeft: "5px" }}
              >
                &deg;F
              </p>
            </div>
            <small className="input-small-text">-63.4 - 248 &deg;F</small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InputsTemperatureRange;
